var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoopWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.708 5.29036C14.0912 4.66948 13.3576 4.17679 12.5495 3.84069C11.7415 3.50458 10.8749 3.33171 9.99967 3.33203C8.23156 3.33203 6.53587 4.03441 5.28563 5.28465C4.03539 6.5349 3.33301 8.23059 3.33301 9.9987C3.33301 11.7668 4.03539 13.4625 5.28563 14.7127C6.53587 15.963 8.23156 16.6654 9.99967 16.6654C13.108 16.6654 15.6997 14.5404 16.4413 11.6654H14.708C14.3647 12.64 13.7275 13.484 12.8841 14.0811C12.0408 14.6781 11.033 14.9987 9.99967 14.9987C8.67359 14.9987 7.40182 14.4719 6.46414 13.5342C5.52646 12.5966 4.99967 11.3248 4.99967 9.9987C4.99967 8.67262 5.52646 7.40085 6.46414 6.46316C7.40182 5.52548 8.67359 4.9987 9.99967 4.9987C11.383 4.9987 12.6163 5.5737 13.5163 6.48203L10.833 9.16536H16.6663V3.33203L14.708 5.29036Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopWhite);
export default __webpack_public_path__ + "static/media/loop-white.c7df55ac2b69be2c3575ef7fb2383fb7.svg";
export { ForwardRef as ReactComponent };